import {FeatureAppDefinition, FeatureServices, Logger} from '@feature-hub/core'
import {ReactFeatureApp} from '@feature-hub/react'
import React from 'react'
import {App} from './app/app'
import store from './app/store'
import {Provider} from 'react-redux'
import {FeatureServicesContext} from './use-feature-services'
import {LayerManagerV2} from '@volkswagen-onehub/layer-manager'
import {ThemeProvider} from '@volkswagen-onehub/components-core'
import './i18n'

export interface StarterFeatureAppDependencies extends FeatureServices {
    readonly 's2:logger'?: Logger
    readonly 'layer-manager'?: LayerManagerV2
}
export interface FeatureAppFlotteConfig {
    featureAppId?: string
    backendUrl: string
    source: string
    previewDate: string | undefined
}

export const featureAppDefinition: FeatureAppDefinition<
    ReactFeatureApp,
    StarterFeatureAppDependencies,
    FeatureAppFlotteConfig
> = {
    optionalDependencies: {
        featureServices: {
            's2:logger': '^1.0.0',
            'fa-content-service': '^1.0.0',
            's2:history': '^2.0.0',
            'layer-manager': '^2.5.0',
            'service-config-provider': '1.0.0',
            'tracking': '^1.0.0',
            'mydealer-service': '^2.0.0',
        },
    },
    create: ({featureAppId, featureServices, config}) => {
        const faContentService = featureServices['fa-content-service'] as any

        const backendUrl =
            (faContentService && faContentService.content?.backendUrl) ||
            config?.backendUrl

        if (!backendUrl) {
            throw new Error('No backendUrl is configured!')
        }

        const serviceType = faContentService.content.service_type

        if (faContentService.content.service_type === undefined) {
            throw new Error('No serviceType is configured!')
        }

        return {
            render() {
                return (
                    <FeatureServicesContext.Provider value={featureServices}>
                        <ThemeProvider theme="main">
                            <Provider store={store}>
                                <App
                                    featureAppId={featureAppId}
                                    backendUrl={backendUrl}
                                    serviceType={serviceType}
                                    previewDate={
                                        faContentService.content?.preview_date
                                    }
                                />
                            </Provider>
                        </ThemeProvider>
                    </FeatureServicesContext.Provider>
                )
            },
        }
    },
}

export default featureAppDefinition
